import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core';
import styles from './styles.scss';

const AvatarCustom = function AvatarCustom(props) {
    const {
        author, avatarsrc,
    } = props;

    const avatarText = author[0];
    const useStyles = makeStyles({
        randomColorStyle: {
            backgroundColor: '#f4f8f9',
        },
    });

    const classes = useStyles();

    return (
        <div className={styles.avatar}>
            <Avatar className={`${styles['avatar-size']} ${classes.randomColorStyle}`} src={avatarsrc}>
                {avatarText}
            </Avatar>
        </div>
    );
};

AvatarCustom.propTypes = {
    author: PropTypes.string.isRequired,
    avatarsrc: PropTypes.string,
};

AvatarCustom.defaultProps = {
    avatarsrc: '',
};

export default AvatarCustom;
